import React from 'react';
import { Tooltip, TooltipProps } from 'antd';
import cx from 'classnames';

import SVGTip from '@/assets/imgs/tip.svg?react';

import styles from './index.module.less';

interface IProps {
  title?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  tooltipProps?: TooltipProps;
  tooltipClassName?: string;
}

/** 问号及说明 */
const IntroduceTip: React.FC<IProps> = (props) => {
  const { title, style, className, tooltipProps } = props;
  return (
    <Tooltip title={title} {...tooltipProps}>
      <span>
        <SVGTip className={cx(styles['it_icon'], className)} style={style} />
      </span>
    </Tooltip>
  );
};

export default IntroduceTip;
